import React from 'react';

import {
  AdornedInput,
  Adornment,
  DatePicker,
  DatePickerInput,
  FormField,
  FormHelp,
  IconCalendarOutline,
  Label,
} from '@zillow/constellation';

import type { Section } from '../../../models';
import { DEMOLITION } from '../../../constants';
import YesAndNoExpansion from '../../../components/Widgets/YesAndNoExpansion';
import { DATE_PICKER_FORMAT, DATE_PICKER_PLACEHOLDER } from '../../../constants/stringConstants';
import { disablePastDates } from '../../../constants/functionConstants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function Demolition({ section, setSectionValues }: Props) {
  function onNoDemolition(): void {
    setSectionValues({
      [DEMOLITION.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesDemolition(): void {
    setSectionValues({
      [DEMOLITION.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  function onDemolitionDateChange(date: Date): void {
    setSectionValues({
      [DEMOLITION.FIELD_NAME.DEMOLITION_DATE]: date,
    });
  }

  return (
    <FormField
      label={<Label size="lg">Is the property scheduled to be demolished?</Label>}
      control={
        <YesAndNoExpansion
          yesHandler={onYesDemolition}
          noHandler={onNoDemolition}
          yesActive={section.getFieldValue(DEMOLITION.FIELD_NAME.IS_ENABLED)}
        >
          <FormField
            label={<Label>What is the expected demolition date?</Label>}
            control={
              <AdornedInput
                input={
                  <DatePickerInput
                    placeholder={DATE_PICKER_PLACEHOLDER}
                    value={section.getFieldValue(DEMOLITION.FIELD_NAME.DEMOLITION_DATE)}
                    onChange={onDemolitionDateChange}
                    datepicker={<DatePicker dateFormat={DATE_PICKER_FORMAT} disabledDates={disablePastDates} />}
                  />
                }
                rightAdornment={
                  <Adornment>
                    <IconCalendarOutline />
                  </Adornment>
                }
              />
            }
            description={
              <FormHelp>
                On or after this date, active lease agreements will terminate for the property. You also must disclose
                to tenants if you have obtained a demolition permit for the property.
              </FormHelp>
            }
          />
        </YesAndNoExpansion>
      }
    />
  );
}

Demolition.description =
  'Date on which the property is to be demolished. There is no validation as this is not a legal requirement, just a disclosure.';

export default Demolition;
